let Security ={
    APIKEY: "OSCORPWEBSERVICE-ADWS-RAWR-TESDG-QWRTT-35SQ",
    SESSION_ID:""
}

export default Security